export default __webpack_public_path__ + "media/icons/upload-route-icon-14afa626.svg";